// extracted by mini-css-extract-plugin
export default {"button":"FlowInsightsNavigationButton_button__l13pw"};